import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/styles/category.css";
import "../../assets/styles/distributors.css";
import { MdOutlineModeEdit, MdDeleteOutline } from "react-icons/md";
import { HiDotsVertical } from "react-icons/hi";
import { IoBagAdd, IoEye } from "react-icons/io5";
import Toggle from "../../components/common/toggle";
import Modal from "../../components/common/modal";
import dist1 from "../../assets/images/categ1.png";
import Pagination, { usePagination } from "../../components/common/pagination";
import { useViewDistributor } from "../../hooks/distributor/distributor.showall"
import Swal from "sweetalert2";
import { toast } from "react-hot-toast";
import { useDistributorUpdate } from "../../hooks/distributor/distributor.edit";




const DistributorsList = () => {
  const [distributorsData, setDistributorsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  const [openMenuId, setOpenMenuId] = useState(null);
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("view"); // "view" or "edit"
  const [editFormData, setEditFormData] = useState({
    id: "",
    companyName: "",
    contactPerson: "",
    designation: "",
    country: "",
    accessStatus: "",
    otpVerificationDays: "",
  });

  const {data : distributorData} = useViewDistributor(debouncedSearchQuery);
  const [imagePreview, setImagePreview] = useState("");
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const { mutate: updateDistributor } = useDistributorUpdate();

  const getDistributorLogoUrl = (logo) => {
    if (!logo) return dist1;
    if (logo.startsWith("http://") || logo.startsWith("https://") || logo.startsWith("data:")) {
      return logo;
    }
    return `${process.env.REACT_APP_BASE_IMAGE}/${logo}`;
  };

  const normalizeAccessStatus = (value) => {
    if (value === true) return "active";
    if (value === false) return "inactive";
    if (typeof value === "string") {
      return value.toLowerCase() === "inactive" ? "inactive" : "active";
    }
    return "active";
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 400);

    return () => clearTimeout(timer);
  }, [searchQuery]);



    useEffect(() => {
    if (distributorData && distributorData.data && Array.isArray(distributorData.data)) {
      const mappedData = distributorData.data.map(dist => ({
        id: dist._id,
        logo: dist.logo,
        companyName: dist.companyName,
        website: dist.website,
        country: dist.country,
        noOfUsers: dist.noOfUsers || 0,
        accessStatus: normalizeAccessStatus(dist.accessStatus)
      }));
      setDistributorsData(mappedData);
    }
  }, [distributorData]);

  // Pagination hook
  const { currentItems, currentPage, totalPages, handlePageChange, setCurrentPage } = usePagination(distributorsData, itemsPerPage);

  useEffect(() => {
    setCurrentPage(1);
  }, [itemsPerPage, debouncedSearchQuery, setCurrentPage]);

  const readURL = (input) => {
    if (input.files && input.files[0]) {
      const reader = new FileReader();
      reader.onload = function (e) {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(input.files[0]);
    }
  };

  const handleOpenModal = (distributor, mode) => {
    setModalMode(mode);

    console.log("Opening modal for distributor:", distributor);
    setEditFormData({
      id: distributor.id, 
      companyName: distributor.companyName,
      contactPerson: distributor.contactPerson || "",
      website: distributor.website || "",
      logo: distributor.logo || "",
      accessStatus: normalizeAccessStatus(distributor.accessStatus),
      country: distributor.country,
      otpVerificationDays: distributor.otpVerificationDays || "",
    });
    setImagePreview(getDistributorLogoUrl(distributor.logo));
    setIsModalOpen(true);
    setOpenMenuId(null);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditFormData({
      id: "",
      companyName: "",
      contactPerson: "",
      logo: "",
      website: "",
      country: "",
      otpVerificationDays: "",
      accessStatus: "active",
    });
    setImagePreview("");
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", editFormData);
    updateDistributor(
      { id: editFormData.id, body: editFormData },
      {
        onSuccess: () => {
          toast.success("Distributor updated successfully!");
          handleCloseModal();
        },
      }
    );
  };

  const handleToggleStatus = (id, newStatus) => {
    const nextAccessStatus = newStatus ? "active" : "inactive";
    const previousDistributor = distributorsData.find((distributor) => distributor.id === id);

    setDistributorsData((prev) =>
      prev.map((distributor) =>
        distributor.id === id
          ? { ...distributor, accessStatus: nextAccessStatus }
          : distributor,
      ),
    );

    updateDistributor(
      {
        id,
        body: { accessStatus: nextAccessStatus },
      },
      {
        onSuccess: () => {
          toast.success(`Distributor marked as ${nextAccessStatus}.`);
        },
        onError: () => {
          setDistributorsData((prev) =>
            prev.map((distributor) =>
              distributor.id === id
                ? {
                    ...distributor,
                    accessStatus: previousDistributor?.accessStatus || "active",
                  }
                : distributor,
            ),
          );
          toast.error("Failed to update distributor status.");
        },
      }
    );
  };

const handleDelete = (id) => {
  Swal.fire({
    title: "Delete Distributor?",
    text: "Are you sure you want to delete this distributor?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it",
    cancelButtonText: "Cancel",
  }).then((result) => {
    if (result.isConfirmed) {
      setDistributorsData((prev) =>
        prev.filter((distributor) => distributor.id !== id)
      );

      toast.success("Distributor deleted successfully!");
    }
  });
};


  const handleRowClick = (distributor) => {
    navigate(`/distributors/view/${distributor.id}`, {
      state: { distributor },
    });
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    if (openMenuId === null && activeDropdown === null) return;
    const handleClick = (e) => {
      if (
        !e.target.closest(".category-dropdown-menu") &&
        !e.target.closest(".downArrow") &&
        !e.target.closest(".action-dropdown") &&
        !e.target.closest(".action-icon")
      ) {
        setOpenMenuId(null);
        setActiveDropdown(null);
      }
    };
    window.addEventListener("mousedown", handleClick);
    return () => window.removeEventListener("mousedown", handleClick);
  }, [openMenuId, activeDropdown]);


  return (
    <>
      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title={modalMode === "view" ? "View Distributor" : "Edit Distributor"}
      >
        <div className="body">
          <form onSubmit={handleEditSubmit}>
            <div className="form-headerr">
              <div className="image-upload-section">
                <h4>Profile</h4>
                <div className="avatar-upload" style={{ margin: "0" }}>
                  <div className="avatar-edit">
                    <input
                      type="file"
                      id="imageUpload"
                      accept=".png, .jpg, .jpeg"
                      onChange={(e) => readURL(e.target)}
                      disabled={modalMode === "view"}
                    />
                    {modalMode === "edit" && <label htmlFor="imageUpload"></label>}
                  </div>
                  <div className="avatar-preview">
                    <div
                      id="imagePreview"
                      style={{
                        backgroundImage: `url(${imagePreview})`,
                      }}
                    ></div>
                  </div>
                </div>
              </div>

              <div className="distributor-form-group">
                <label
                  htmlFor="edit-name"
                  className="distributor-label"
                >
                  Distributor Name
                </label>
                <input
                  type="text"
                  id="edit-name"
                  name="companyName"
                  value={editFormData.companyName}
                  onChange={(e) => {
                    const { name, value } = e.target;
                    setEditFormData({ ...editFormData, [name]: value });
                  }}
                  disabled={modalMode === "view"}
                />
              </div>
              <div className="distributor-form-group">
                <label
                  htmlFor="edit-website"
                  className="distributor-label"
                >
                  Website
                </label>
                <input
                  type="text"
                  id="edit-website"
                  name="website"
                  value={editFormData.website}
                  onChange={(e) => {
                    const { name, value } = e.target;
                    setEditFormData({ ...editFormData, [name]: value });
                  }}
                  disabled={modalMode === "view"}
                />
              </div>
              <div className="distributor-form-group">
                <label
                  htmlFor="edit-country"
                  className="distributor-label"
                >
                  Country
                </label>
                <input
                  type="text"
                  id="edit-country"
                  name="country"
                  value={editFormData.country}
                  onChange={(e) => {
                    const { name, value } = e.target;
                    setEditFormData({ ...editFormData, [name]: value });
                  }}
                  disabled={modalMode === "view"}
                />
              </div>
              <div className="distributor-form-group">
                <label
                  htmlFor="edit-otp-days"
                  className="distributor-label"
                >
                  Otp Verification Days
                </label>
                <input
                  type="text"
                  id="edit-otp-days"
                  name="otpVerificationDays"
                  value={editFormData.otpVerificationDays}
                  onChange={(e) => {
                    const { name, value } = e.target;
                    setEditFormData({ ...editFormData, [name]: value });
                  }}
                  disabled={modalMode === "view"}
                />
              </div>

              <div className="container">
                <label htmlFor="">Status</label>
                <div className="radioBtns">
                  <div className="radio">
                    <input
                      id="radio-1"
                      name="radio"
                      type="radio"
                      value="active"
                      checked={editFormData.accessStatus === "active"}
                      onChange={(e) =>
                        setEditFormData({ ...editFormData, accessStatus: e.target.value })
                      }
                      disabled={modalMode === "view"}
                    />
                    <label htmlFor="radio-1" className="radio-label">
                      Active
                    </label>
                  </div>

                  <div className="radio">
                    <input
                      id="radio-2"
                      name="radio"
                      type="radio"
                      value="inactive"
                      checked={editFormData.accessStatus === "inactive"}
                      onChange={(e) =>
                        setEditFormData({ ...editFormData, accessStatus: e.target.value })
                      }
                      disabled={modalMode === "view"}
                    />
                    <label htmlFor="radio-2" className="radio-label">
                      Inactive
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {modalMode === "edit" && (
              <div className="distributor-modal-footer">
                <button type="submit" className="commonButton">
                  Save Changes
                </button>
              </div>
            )}
          </form>
        </div>
      </Modal>

      <div className="distributor-list-container">
        <div
          className="distributor-header-actions"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "12px",
            flexWrap: "wrap",
            marginBottom: "12px",
          }}
        >
          <div
            className="distributor-search-wrap"
            style={{ flex: "1 1 600px", minWidth: "220px" }}
          >
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search distributors..."
              style={{
                width: "100%",
                padding: "8px 10px",
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                fontSize: "14px",
              }}
            />
          </div>

          <button
            className="commonButton distributor-add-btn"
            onClick={() => navigate("/distributors/AddDistributors")}
          >
            <IoBagAdd size={20} color="#ffffff" />
            Add Distributor
          </button>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "12px",
          }}
        >
          <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px" }}>
            Items per page:
            <select
              id="distributor-items-per-page"
              value={itemsPerPage}
              onChange={(e) => setItemsPerPage(Number(e.target.value))}
              style={{ padding: "4px 8px" }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
            </select>
          </label>
        </div>

        <div>

        </div>

        <div className="distributor-table-container">
          <table className="distributor-table">
            <thead>
              <tr className="distributor-table-head-tr">
                <th className="distributor-th">Logo</th>
                <th className="distributor-th">Company Name</th>
                <th className="distributor-th">Website</th>
                <th className="distributor-th">Country</th>
                <th className="distributor-th">No. of Users</th>
                <th className="distributor-th">Status</th>
                <th className="distributor-th">Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((distributor) => (
                <tr
                  key={distributor.id}
                  className="distributor-tr"
                  onClick={() => handleRowClick(distributor)}
                >
                  <td className="distributor-td">
                    <img
                      src={getDistributorLogoUrl(distributor.logo)}
                      alt={distributor.companyName}
                      className="distributor-td-img"
                      onError={(e) => {
                        e.target.onerror = null; 
                        e.target.src = dist1;
                      }}
                    />
                  </td>
                  <td className="distributor-td distributor-company-name">
                    {distributor.companyName}
                  </td>
                  <td className="distributor-td" onClick={(e) => e.stopPropagation()}>
                    <a
                      href={`https://${distributor.website}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="distributor-website-link"
                    >
                      {distributor.website}
                    </a>
                  </td>
                  <td className="distributor-td distributor-text-secondary">{distributor.country}</td>
                  <td className="distributor-td distributor-text-center distributor-text-secondary">
                    {distributor.noOfUsers}
                  </td>
                  <td className="distributor-td" onClick={(e) => e.stopPropagation()}>
                    <Toggle
                      checked={normalizeAccessStatus(distributor.accessStatus) === "active"}
                      onChange={(newStatus) =>
                        handleToggleStatus(distributor.id, newStatus)
                      }
                    />
                  </td>
                  <td className="distributor-td distributor-text-center" onClick={(e) => e.stopPropagation()}>
                    <div className="distributor-action-container">
                      <HiDotsVertical
                        className="distributor-action-icon"
                        color="#898989"
                        size={20}
                        onClick={() =>
                          setActiveDropdown(
                            activeDropdown === distributor.id ? null : distributor.id
                          )
                        }
                      />
                      {activeDropdown === distributor.id && (
                        <div
                          className="category-dropdown-menu distributor-action-dropdown-menu"
                        >
                          <div
                            className="category-dropdown-item distributor-dropdown-item"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(`/distributors/view/${distributor.id}`, { state: { distributor } });
                            }}
                          >
                            <IoEye className="icons" size={16} /> View
                          </div>
                          <div
                            className="category-dropdown-item distributor-dropdown-item"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleOpenModal(distributor, "edit");
                            }}
                          >
                            <MdOutlineModeEdit className="icons" size={16} /> Edit
                          </div>
                          <div
                            className="category-dropdown-item distributor-dropdown-item distributor-dropdown-item-delete"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDelete(distributor.id);
                            }}
                          >
                            <MdDeleteOutline className="icons" size={16} /> Delete
                          </div>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {distributorsData.length === 0 && (
          <div className="distributor-empty-state">
            No distributors found. Click "Add Distributor" to create one.
          </div>
        )}
      </div>

      <div style={{ marginTop: "20px", display: "flex", justifyContent: "center" }}>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
    </>
  );
};

export default DistributorsList;